var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbSetup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8697",
    "data-name": "Rectangle 8697",
    width: 17.537,
    height: 10.825,
    fill: "#0072ce"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Carb_Setup"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Carb_Setup",
    "data-name": "Carb Setup",
    clipPath: "url(#clip-Carb_Setup)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11785",
    "data-name": "Group 11785",
    transform: "translate(0.231 3.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11784",
    "data-name": "Group 11784",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22239",
    "data-name": "Path 22239",
    d: "M17.537,1.833v7.14c-.025.011-.023.034-.026.056a1.947,1.947,0,0,1-.159.572,1.984,1.984,0,0,1-.508.7,2.065,2.065,0,0,1-1.866.463,1.824,1.824,0,0,1-.548-.226,2.064,2.064,0,0,1-.588-.519,2.092,2.092,0,0,1-.339-.646c-.015-.049-.031-.089-.1-.089q-1.285,0-2.571,0a.088.088,0,0,0-.1.074,1.818,1.818,0,0,1-.295.6,1.965,1.965,0,0,1-1.12.786,1.891,1.891,0,0,1-1.182-.029,2.559,2.559,0,0,1-.4-.178,2.057,2.057,0,0,1-.589-.512,1.986,1.986,0,0,1-.35-.668.091.091,0,0,0-.109-.076c-.095.005-.19,0-.286,0H4.145c-.057,0-.086,0-.113.076a2.733,2.733,0,0,1-.21.462,2.018,2.018,0,0,1-.838.78,2.06,2.06,0,0,1-2.107-.15,1.971,1.971,0,0,1-.683-.815A1.842,1.842,0,0,1,0,8.883Q0,5.544,0,2.205a2.322,2.322,0,0,1,.147-.918A2.082,2.082,0,0,1,.65.551,1.988,1.988,0,0,1,1.57.059,2.068,2.068,0,0,1,2.69.1a2.042,2.042,0,0,1,.826.51,2.276,2.276,0,0,1,.521.863c.023.063.044.076.1.076q1.269,0,2.538,0a.1.1,0,0,0,.113-.085,2.212,2.212,0,0,1,.294-.6,1.94,1.94,0,0,1,.47-.477A2.168,2.168,0,0,1,8.338.043,2.135,2.135,0,0,1,9.079.022a1.85,1.85,0,0,1,.8.306,2.165,2.165,0,0,1,.472.426,1.788,1.788,0,0,1,.38.727c.016.067.063.067.117.067q1.258,0,2.516,0c.069,0,.107-.017.127-.085a1.947,1.947,0,0,1,.283-.584A2.106,2.106,0,0,1,14.59.2,1.724,1.724,0,0,1,15.2.016a2.217,2.217,0,0,1,1.03.128A2.1,2.1,0,0,1,17.108.8a1.724,1.724,0,0,1,.39.932c0,.034,0,.075.038.1M16.5,5.395h0q0-1.664,0-3.328a.992.992,0,0,0-.11-.495,1.041,1.041,0,0,0-1.692-.2,1.071,1.071,0,0,0-.259.718.514.514,0,0,1-.477.473,2.868,2.868,0,0,0-.351,0c-1.12,0-2.241,0-3.361,0A.549.549,0,0,1,9.8,2.108a1.013,1.013,0,0,0-.554-.961.958.958,0,0,0-.882-.04,1.01,1.01,0,0,0-.629.949.5.5,0,0,1-.487.5c-.1,0-.2,0-.3,0l-3.405,0A.475.475,0,0,1,3.1,2.113a1.135,1.135,0,0,0-.232-.7,1.039,1.039,0,0,0-1.628.013,1.039,1.039,0,0,0-.165.312,2.148,2.148,0,0,0-.059.661q0,3.136,0,6.271a1.1,1.1,0,0,0,.183.66,1,1,0,0,0,.734.443,1,1,0,0,0,1.152-.937.7.7,0,0,1,.069-.327.591.591,0,0,1,.554-.27c.74,0,1.479,0,2.219,0,.439,0,.879-.008,1.318.009a.494.494,0,0,1,.491.506,1.124,1.124,0,0,0,.188.589A1.03,1.03,0,0,0,9.8,8.752a.523.523,0,0,1,.48-.5c.545-.006,1.091-.007,1.636-.008.641,0,1.282,0,1.922,0a.532.532,0,0,1,.6.525,1.049,1.049,0,0,0,.192.6,1,1,0,0,0,.762.419,1.016,1.016,0,0,0,.887-.385,1.082,1.082,0,0,0,.219-.731q0-1.636,0-3.273",
    transform: "translate(0 0)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22240",
    "data-name": "Path 22240",
    d: "M92.543,47.9a1.806,1.806,0,1,1-1.8-1.82,1.813,1.813,0,0,1,1.8,1.82m-2.571-.034a.769.769,0,1,0,1.538.018.791.791,0,0,0-.764-.773.775.775,0,0,0-.774.755",
    transform: "translate(-81.973 -42.475)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22241",
    "data-name": "Path 22241",
    d: "M28.063,49.69a1.805,1.805,0,1,1,1.821-1.8,1.816,1.816,0,0,1-1.821,1.8m-.751-1.806a.77.77,0,1,0,1.54-.024.788.788,0,0,0-.8-.749.773.773,0,0,0-.742.774",
    transform: "translate(-24.214 -42.474)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22242",
    "data-name": "Path 22242",
    d: "M155.205,47.892a1.8,1.8,0,1,1-1.8-1.818,1.817,1.817,0,0,1,1.8,1.818m-1.808-.778a.768.768,0,1,0,0,1.535.763.763,0,0,0,.773-.773.756.756,0,0,0-.777-.762",
    transform: "translate(-139.733 -42.469)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22243",
    "data-name": "Path 22243",
    d: "M20.233,20.828a.509.509,0,0,1-.071-1.014.51.51,0,1,1,.071,1.014",
    transform: "translate(-18.169 -18.263)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22244",
    "data-name": "Path 22244",
    d: "M20.748,105.892a.54.54,0,0,1-.515.507.532.532,0,0,1-.513-.523.514.514,0,1,1,1.029.017",
    transform: "translate(-18.176 -97.12)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22245",
    "data-name": "Path 22245",
    d: "M191.709,106.466a.515.515,0,0,1-.517-.524.514.514,0,0,1,1.028,0,.517.517,0,0,1-.51.521",
    transform: "translate(-176.231 -97.186)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22246",
    "data-name": "Path 22246",
    d: "M105.85,20.825a.51.51,0,1,1,.515-.493.506.506,0,0,1-.515.493",
    transform: "translate(-97.088 -18.26)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22247",
    "data-name": "Path 22247",
    d: "M105.9,105.388a.509.509,0,0,1,.509.513.52.52,0,0,1-.51.518.525.525,0,0,1-.519-.519.516.516,0,0,1,.52-.511",
    transform: "translate(-97.136 -97.141)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22248",
    "data-name": "Path 22248",
    d: "M191.663,20.753a.5.5,0,0,1-.515-.508.522.522,0,0,1,.578-.508.538.538,0,0,1,.457.519.5.5,0,0,1-.52.5",
    transform: "translate(-176.19 -18.191)",
    fill: "#0072ce"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbSetup);
export default __webpack_public_path__ + "static/media/Carb Setup.803fa7bbfc1f3321483308d5fbb668a0.svg";
export { ForwardRef as ReactComponent };